import { render, staticRenderFns } from "./confirmationModal.vue?vue&type=template&id=c37d38e2&scoped=true&"
import script from "./confirmationModal.vue?vue&type=script&lang=js&"
export * from "./confirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmationModal.vue?vue&type=style&index=0&id=c37d38e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d38e2",
  null
  
)

export default component.exports